import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import styles from './table.module.css';
/**
 * 
 * @param {object | array-like} column The style to be applied to each column of Table
 * @param {JSX.Element | string} emptyComponent What to render when data passed is empty
 * @param {array } data The data to be displayed
 * @param {bool } heading Shows the header of a table
 */
const TableDisplay = ({column={0:{field:"name",title:"Name",headerStyle:{},cellStyle:{}, renderItem:(rowData) => {}}}, data =[],heading=false, emptyComponent}) => {
    // data.forEach(datum => {
    //     if(!datum) return null;
    // })
    const randomDatum = useMemo(() => data[Math.floor(Math.random() * data.length )],[data?.length]) ;

    if(!randomDatum) return emptyComponent || null;
    const tableArray = new Array(Object.keys(randomDatum).length).fill(0);
    return (
        <div className={`scroller ${styles.TableRoot}`}>
            <table>
                {
                    heading && (
                        <thead className='w-full'>
                            <tr className='w-full'>
                                {
                                    tableArray.map((_,ind) => {
                                       return column[ind]? (
                                       <th key={ind}style={{...column[ind].headerStyle}}>{column[ind].title}</th>
                                       ): null
                                    })
                                }
                            </tr>
                        </thead>
                    )
                    
                }
                <tbody>
                     { data.map((datum,index) => {
                             return (<tr key={datum?.id || Math.random().toString(16)}>
                                 {
                                     tableArray.map((_, ind) => {
                                         return column[ind] ? (
                                            <td key={datum?.id + " - "+ind} style={{...column[ind].cellStyle}}>
                                                {
                                                   column[ind].renderItem? column[ind].renderItem(datum || {}) : datum?.[column[ind].field]  
                                                }
                                            </td>
                                         ): null
                                     })
                                 }
                             </tr>)
                         })
                     }   
                </tbody>
            </table>
        </div>
    )
}

TableDisplay.propTypes = {
    column: PropTypes.object,
    data:PropTypes.array.isRequired,
    heading:PropTypes.bool,
    emptyComponent:PropTypes.element,
}

export default TableDisplay;